import { styled , Typography, } from "@mui/material";



export const Logo = styled("img")({
  width: "140px",
  height: "auto",
  opacity: 1,
  paddingBottom: "6px", 
  });

 export const LogoText = styled(Typography)({
    fontFamily: "Montserrat Alternates",
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24.38px",
    textAlign: "left",
    marginLeft: "17px",
    transition: "color 0.3s",
    cursor:"pointer",
    "&:hover": {
      color: "#4A47E0", 
    },
  });
  
 export const LogoTextSpan = styled("span")({
    fontWeight: 600,
  });
  
  export const LogoTextSpan1 = styled("span")({
    color: "#4880FF",
  });
  